import { capIcon } from './capIcon'
import { alertIcon } from './alertIcon'

export const modalType = {
  DONE: {
    icon: capIcon,
    color: 'success',
  },
  ALERT: {
    icon: alertIcon,
    color: 'red',
  }
}

export const modalIcon = (type) => `
  <div data-exam-result-form-target="modalIcon" class="mx-auto flex items-center justify-center h-12 w-12 rounded-2xl bg-${type.color}-100">
    ${type.icon}
  </div>
`
